module.exports = __webpack_public_path__ + "static/media/usersSetup.1b5986bf.png";